import React, { useCallback, type FormEvent } from 'react';
import Input from '@atlaskit/textfield';
import { useIntl } from '@atlassian/jira-intl';
import type { DefaultDateTimeProps as Props } from '../../common/types.tsx';
import { StyledRow, ChildWrapper, FixedChildWrapper } from '../../common/ui/styled.tsx';
import messages from './messages.tsx';

const InRangeOf = ({ value: { value1 = '', value2 = '' }, onChange, isInvalid }: Props) => {
	const { formatMessage } = useIntl();

	const onChangeValue1Date = useCallback(
		(event: FormEvent<HTMLInputElement>) => {
			onChange({
				value1: event.currentTarget.value,
				value2,
			});
		},
		[onChange, value2],
	);

	const onChangeValue2Date = useCallback(
		(event: FormEvent<HTMLInputElement>) => {
			onChange({
				value1,
				value2: event.currentTarget.value,
			});
		},
		[onChange, value1],
	);

	return (
		<StyledRow>
			<ChildWrapper>
				<Input
					isInvalid={isInvalid}
					name="value1"
					onChange={onChangeValue1Date}
					value={value1}
					placeholder="-3w 4d 12h 30m"
					isCompact
					autoComplete="off"
					testId="jql-builder-basic-datetime.ui.in-range-of-time.input-1"
					aria-label={formatMessage(messages.startTimeRangeLabel)}
				/>
			</ChildWrapper>
			<FixedChildWrapper>{formatMessage(messages.to)}</FixedChildWrapper>
			<ChildWrapper>
				<Input
					isInvalid={isInvalid}
					name="value2"
					onChange={onChangeValue2Date}
					value={value2}
					placeholder="3w 4d 12h 30m"
					isCompact
					autoComplete="off"
					testId="jql-builder-basic-datetime.ui.in-range-of-time.input-2"
					aria-label={formatMessage(messages.endTimeRangeLabel)}
				/>
			</ChildWrapper>
		</StyledRow>
	);
};

export default InRangeOf;
